import { apiClient } from './apiClient'
import { Friend, FriendResultsPage, FriendshipRequest, Result, QRTokenResponse } from '../types/dtos'

export const friendService = {
  // Get all accepted friends
  async getFriends(): Promise<Friend[]> {
    const response = await apiClient.get<Friend[]>('/friends')
    return response.data
  },

  // Get a single friend with club info (profile header)
  async getFriend(userId: number): Promise<Friend> {
    const response = await apiClient.get<Friend>(`/friends/${userId}`)
    return response.data
  },

  // Send friend request by email
  async sendFriendRequest(email: string): Promise<void> {
    await apiClient.post('/friends/request', { email })
  },

  // Get pending incoming requests
  async getPendingRequests(): Promise<FriendshipRequest[]> {
    const response = await apiClient.get<FriendshipRequest[]>('/friends/pending')
    return response.data
  },

  // Get sent outgoing requests
  async getSentRequests(): Promise<FriendshipRequest[]> {
    const response = await apiClient.get<FriendshipRequest[]>('/friends/sent')
    return response.data
  },

  // Accept friend request
  async acceptRequest(requestId: number): Promise<FriendshipRequest> {
    const response = await apiClient.put<FriendshipRequest>(`/friends/requests/${requestId}/accept`)
    return response.data
  },

  // Decline friend request
  async declineRequest(requestId: number): Promise<FriendshipRequest> {
    const response = await apiClient.put<FriendshipRequest>(`/friends/requests/${requestId}/decline`)
    return response.data
  },

  // Cancel sent friend request
  async cancelRequest(requestId: number): Promise<FriendshipRequest> {
    const response = await apiClient.delete<FriendshipRequest>(`/friends/requests/${requestId}`)
    return response.data
  },

  // Remove friend
  async removeFriend(friendId: number): Promise<unknown> {
    const response = await apiClient.delete(`/friends/${friendId}`)
    return response.data
  },

  // Block user
  async blockUser(userId: number): Promise<unknown> {
    const response = await apiClient.post(`/friends/block/${userId}`)
    return response.data
  },

  // Generate QR token
  async generateQRToken(): Promise<QRTokenResponse> {
    const response = await apiClient.post<QRTokenResponse>('/friends/qr/generate')
    return response.data
  },

  // Accept friendship via QR token
  async acceptQRToken(token: string): Promise<Friend> {
    const response = await apiClient.post<Friend>('/friends/qr/accept', { token })
    return response.data
  },

  // View friend's scorecard
  async viewFriendScorecard(resultId: number): Promise<Result> {
    const response = await apiClient.get<Result>(`/friends/results/${resultId}/view`)
    return response.data
  },

  // Get a friend's recent rounds (paged)
  async getFriendResults(userId: number, limit: number, offset: number): Promise<FriendResultsPage> {
    const response = await apiClient.get<FriendResultsPage>(
      `/friends/${userId}/results`,
      { params: { limit, offset } }
    )
    return response.data
  }
}

